import { ERowType } from 'src/app/project/shared/enums/row-type.enum';
import Table from '../../site-table/custom-table/table/Table';
import { GET_COLLAPSED_GROUPS, GET_IS_ALL_GROUPS_COLLAPSED } from '../../site-table/table.ui.store';
import Timeline from '../../site-timeline/Timeline';

export function checkIfAllGroupsCollapsed(groupedObject: Timeline | Table): boolean {
  if (!groupedObject || !groupedObject.items) {
    return false;
  }

  const collapsedGroups = GET_COLLAPSED_GROUPS();
  let hasGroup = false;
  let allCollapsed = true;

  for (const item of groupedObject.items) {
    if (
      item.type === ERowType.HEADER ||
      item.type === ERowType.GROUP_1 ||
      item.type === ERowType.GROUP_2 ||
      item.type === ERowType.GROUP_3
    ) {
      hasGroup = true;

      if (!collapsedGroups.has(item.id)) {
        allCollapsed = false;
        break;
      }
    }
  }

  if (!hasGroup) {
    return GET_IS_ALL_GROUPS_COLLAPSED();
  }

  return allCollapsed;
}
